import { render, staticRenderFns } from "./TermsAndPrivacyLayout.vue?vue&type=template&id=670c50b0&scoped=true"
import script from "./TermsAndPrivacyLayout.vue?vue&type=script&lang=js"
export * from "./TermsAndPrivacyLayout.vue?vue&type=script&lang=js"
import style0 from "./TermsAndPrivacyLayout.vue?vue&type=style&index=0&id=670c50b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c50b0",
  null
  
)

export default component.exports